'use strict';

const ConfirmationDialogController = function($scope, $rootScope, NavActions, NavStore, TopControlsActions, TopControlsStore) {

  const vm = this;
  let nav;

  vm.showDialog = false;
  vm.view = 'confirmNavigation';

  vm.closeModal = () => {

    vm.showDialog = false;
    nav = null;
  };

  vm.continue = () => {

    if (nav === 'left') {
      NavActions.ContinueWithNavigation.dispatch();
    }

    if (nav === 'top') {
      TopControlsActions.ContinueWithNavigation.dispatch();
    }

    vm.closeModal();
  };

  vm.handleShowPopupFromLeftNav = () => {

    vm.showDialog = true;
    nav = 'left';
  };

  vm.handleShowPopupFromTopNav = () => {

    vm.showDialog = true;
    nav = 'top';
  };

  NavStore.on(NavStore.Events.ShowPopup, this.handleShowPopupFromLeftNav.bind(this), $scope);
  TopControlsStore.on(TopControlsStore.Events.ShowPopup, this.handleShowPopupFromTopNav.bind(this), $scope);
};

ConfirmationDialogController.$inject = [
  '$scope', '$rootScope', 'NavActions', 'NavStore',
  'TopControlsActions', 'TopControlsStore'
];
module.exports = ConfirmationDialogController;


// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/confirmation/ConfirmationDialogController.js